import CadenceSolutions from './cadence-solutions';

function App() {
  return <CadenceSolutions />;
}

export default App;